import React, { useState, useEffect, useRef } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Facebook,
  Instagram,
  Linkedin,
} from "lucide-react";

const TeamSection = () => {
  const containerRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(3);
  const [cardWidth, setCardWidth] = useState(0);

  const teamMembers = [
  {
    id: 1,
    name: "Emma Brown",
    role: "Project Manager",
    img: "member1.jpg",
    intro: "Leading teams with clarity, planning, and confidence.",
    social: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    id: 2,
    name: "Ali Raza",
    role: "Backend Developer",
    img: "member2.jpg",
    intro: "Building secure APIs and scalable server-side systems.",
    social: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    id: 3,
    name: "Ayesha Khan",
    role: "UI / UX Designer",
    img: "member4.jpg",
    intro: "Designing clean, user-friendly, and intuitive interfaces.",
    social: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    id: 4,
    name: "Hamza Ahmed",
    role: "Machine Learning Engineer",
    img: "member3.jpg",
    intro: "Transforming data into intelligent, predictive solutions.",
    social: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    id: 5,
    name: "Sara Malik",
    role: "QA & Documentation",
    img: "member2.jpg",
    intro: "Ensuring quality, accuracy, and smooth user experience.",
    social: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      linkedin: "https://linkedin.com",
    },
  },
];


  /* RESPONSIVE */
  useEffect(() => {
    const resize = () => {
      if (window.innerWidth < 768) setItemsPerView(1);
      else if (window.innerWidth < 1024) setItemsPerView(2);
      else setItemsPerView(3);

      if (containerRef.current) {
        setCardWidth(containerRef.current.offsetWidth / itemsPerView);
      }
    };

    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [itemsPerView]);

  const maxIndex = teamMembers.length - itemsPerView;

  const next = () => setIndex((i) => Math.min(i + itemsPerView, maxIndex));
  const prev = () => setIndex((i) => Math.max(i - itemsPerView, 0));

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* HEADER */}
        <div className="text-center mb-10">
          <p className="text-orange-500 font-semibold">Our Team</p>
          <h2 className="text-3xl md:text-4xl font-bold">Best Professionals delivering excellence</h2>
        </div>

        <div className="relative">
          {/* PREV */}
          <button
            onClick={prev}
            disabled={index === 0}
            className="absolute -left-4 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow disabled:opacity-40 z-10"
          >
            <ChevronLeft />
          </button>

          {/* SLIDER */}
          <div ref={containerRef} className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${index * cardWidth}px)`,
              }}
            >
              {teamMembers.map((member) => (
                <div
                  key={member.id}
                  style={{ width: cardWidth }}
                  className="flex-shrink-0 px-3"
                >
                  <div className="bg-white rounded-lg shadow hover:shadow-md transition">
                    {/* IMAGE */}
                    <div className="h-44 overflow-hidden rounded-t-lg">
                      <img
                        src={member.img}
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* CONTENT */}
                    <div className="bg-orange-500 p-4 text-center text-white rounded-b-lg">
                      <h3 className="font-semibold text-lg">{member.name}</h3>

                      <p className="text-sm text-orange-100 mb-2">
                        {member.role}
                      </p>

                      <p className="text-sm text-orange-50 mb-4">
                        {member.intro}
                      </p>

                      {/* SOCIAL ICONS – YOUR EXACT STYLE */}
                      <div className="flex justify-center gap-3">
                        <a
                          href={member.social.facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-white bg-opacity-20 p-2 rounded-lg hover:bg-opacity-30 transition-all"
                        >
                          <Facebook size={18} />
                        </a>

                        <a
                          href={member.social.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-white bg-opacity-20 p-2 rounded-lg hover:bg-opacity-30 transition-all"
                        >
                          <Instagram size={18} />
                        </a>

                        <a
                          href={member.social.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-white bg-opacity-20 p-2 rounded-lg hover:bg-opacity-30 transition-all"
                        >
                          <Linkedin size={18} />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* NEXT */}
          <button
            onClick={next}
            disabled={index >= maxIndex}
            className="absolute -right-4 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow disabled:opacity-40 z-10"
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
